import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { RETENTION_STATUSES } from './constants'

const useStyles = makeStyles(() => ({
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 9999,
    padding: '2px 8px',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16px',
    whiteSpace: 'nowrap',
  },
}))

export default function RetentionStatusChip({ status, className, ...props }) {
  const classes = useStyles()
  const meta = RETENTION_STATUSES[status]
  if (!meta) return null

  return (
    <span
      className={className ? `${classes.chip} ${className}` : classes.chip}
      style={{ backgroundColor: meta.background, color: meta.color }}
      {...props}
    >
      {meta.label}
    </span>
  )
}

RetentionStatusChip.propTypes = {
  status: PropTypes.oneOf(Object.keys(RETENTION_STATUSES)).isRequired,
  className: PropTypes.string,
}
